import { Component, DestroyRef, Inject, OnDestroy, OnInit, inject } from '@angular/core';
import { FormBuilder,FormGroup,ReactiveFormsModule} from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { DeviceService } from '../../services/device-service/device.service';
import { map } from 'rxjs/operators';
import { MatDialogRef } from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { Customer,ApiResponse } from '../../models/customer-group.model';
import { CustomerService } from '../../services/customer-service/customer.service';
import { ToastrService } from 'ngx-toastr';
import { FormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AbstractControl, FormArray } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { SelectedCustomerGroupDialogComponent } from '../selected-customer-group-dialog/selected-customer-group-dialog.component';
import { UnsavedChangesTrackerService } from '../../services/unsaved-changes/unsaved-changes-tracker.service';
import {
  bindFormDirtyTracking,
  clearFormUnsavedChanges,
} from '../../services/unsaved-changes/unsaved-changes-form.util';

const ASSIGN_CONFIG_DIRTY_SOURCE = 'assign-verified-configuration';

@Component({
  selector: 'app-config-list-dialog',
  standalone: true,
  imports: [ReactiveFormsModule,CommonModule,MatSelectModule,MatFormFieldModule,MatCheckboxModule,MatDialogModule,
    FormsModule,MatTableModule,MatButtonModule,MatTooltipModule,SelectedCustomerGroupDialogComponent
  ],
  templateUrl: './config-list-dialog.component.html',
  styleUrl: './config-list-dialog.component.scss'
})
export class ConfigListDialogComponent implements OnInit, OnDestroy {
  private readonly destroyRef = inject(DestroyRef);
  private readonly unsavedChanges = inject(UnsavedChangesTrackerService);

  //customers:any;
  groups:any;
  configId:any;
  customersData:any;
  configVersion:any;
  payload:any=[];
  patchCustomerId:any;
  patchGroupId:any;
  selectedGroupIds: number[] = [];
  isDataReady:any = false;
  readonly noAvailableGroupsMessage =
    'The selected customer has no available groups. Please create or assign a group before publishing the configuration.';
  /** Index-aligned with customersData; false when the customer has no assignable groups. */
  customerHasGroups: boolean[] = [];
  constructor(private fb: FormBuilder,@Inject(MAT_DIALOG_DATA) public data: any,private deviceService:DeviceService,
private dialogRef:MatDialogRef<ConfigListDialogComponent>,private customerService:CustomerService,private toastr:ToastrService,
private dialog: MatDialog
) {


  }

form!: FormGroup;
isConfirmEnabled = false;

ngOnInit(): void {
  this.customersAndGroups();
  this.configId = this.data?.configId;
  this.configVersion = this.data?.configVersion;
  this.patchCustomerId = this.data?.cpId;
  this.patchGroupId = this.data?.gpId;
}

customersAndGroups() {
  const page: number = 0;
  const size: number = 500;
  this.customerService.getCustomersAndGroups(page, size).subscribe((response: ApiResponse) => {
    this.customersData = response.data.content;
    this.isDataReady = true;
    this.buildForm();
  });
}

buildForm(): void {
  this.customerHasGroups = this.customersData.map(
    (customer: any) => (customer.groups ?? []).some((group: any) => !group.disabled)
  );

  this.form = this.fb.group({
    customers: this.fb.array(
      this.customersData.map((customer: any, i: number) =>
        this.fb.group({
          customerId: customer.id,
          selected: { value: false, disabled: !this.customerHasGroups[i] },
          groups: this.fb.array(
            (customer.groups ?? [])
              .filter((group: any) => !group.disabled)
              .map((group: any) =>
                this.fb.group({
                  groupId: group.id,
                  selected: false
                })
              )
          )
        })
      )
    )
  });

  this.form.valueChanges.subscribe(() => this.checkConfirmButton());
  bindFormDirtyTracking(
    this.form,
    ASSIGN_CONFIG_DIRTY_SOURCE,
    this.unsavedChanges,
    this.destroyRef
  );

  setTimeout(() => {
    this.customers.controls.forEach((customerCtrl, i) => {
      const customerId = customerCtrl.get('customerId')?.value;
      const groupsArray = this.getGroupsArray(i);

      if (customerId === this.patchCustomerId) {
        // Preselected group
        groupsArray.controls.forEach((groupCtrl, j) => {
          const groupId = this.customersData[i].groups[j]?.id;
          if (groupId === this.patchGroupId) {
            groupCtrl.get('selected')?.setValue(true, { emitEvent: false });
            groupCtrl.disable({ emitEvent: false });
          }
        });

        // Preselected customer - show as unchecked and disabled
        customerCtrl.get('selected')?.setValue(false, { emitEvent: false });
        customerCtrl.get('selected')?.disable({ emitEvent: false });
      }


      // ✅ Group-to-Customer sync
      groupsArray.valueChanges.subscribe(() => {
        const allSelected = groupsArray.controls.every(ctrl => ctrl.get('selected')?.value);
        const anySelected = groupsArray.controls.some(ctrl => ctrl.get('selected')?.value);

        if (customerCtrl.get('selected')?.enabled) {
          customerCtrl.get('selected')?.setValue(allSelected, { emitEvent: false });
        }

        this.checkConfirmButton();
      });
    });

    this.checkConfirmButton();
    clearFormUnsavedChanges(
      this.form,
      ASSIGN_CONFIG_DIRTY_SOURCE,
      this.unsavedChanges
    );
  }, 0);
}

ngOnDestroy(): void {
  this.unsavedChanges.clear(ASSIGN_CONFIG_DIRTY_SOURCE);
}


get customers(): FormArray {
  return this.form.get('customers') as FormArray;
}

getGroupsArray(customerIndex: number): FormArray {
  return this.customers.at(customerIndex).get('groups') as FormArray;
}

onCustomerChange(customerIndex: number): void {
  const customerGroup = this.customers.at(customerIndex);
  const selected = customerGroup.get('selected')?.value;
  const groups = this.getGroupsArray(customerIndex);

  if (!this.customerHasGroups[customerIndex]) {
    customerGroup.get('selected')?.setValue(false, { emitEvent: false });
    if (selected) {
      this.toastr.warning(this.noAvailableGroupsMessage);
    }
    this.checkConfirmButton();
    return;
  }

  groups.controls.forEach(groupCtrl => {
    if (!groupCtrl.get('disabled')?.value) {
      groupCtrl.get('selected')?.setValue(selected, { emitEvent: false });
    }
  });

  this.checkConfirmButton();
}

checkConfirmButton(): void {
  this.isConfirmEnabled = this.customers.controls.some(customerCtrl => {
    const groups = customerCtrl.get('groups') as FormArray;
    return groups.controls.some(g => this.isAssignableGroupSelected(g));
  });
}

/** The pre-assigned group is checked but disabled; it is not a new target for publishing. */
private isAssignableGroupSelected(groupCtrl: AbstractControl): boolean {
  return (
    groupCtrl.enabled &&
    groupCtrl.get('selected')?.value === true &&
    groupCtrl.get('groupId')?.value !== this.patchGroupId
  );
}

private hasSelectedCustomerWithoutGroups(): boolean {
  return this.customers.controls.some(
    (customerCtrl, i) =>
      !this.customerHasGroups[i] && customerCtrl.get('selected')?.value === true
  );
}

onConfirm(): void {
  const selectedData = this.customers.controls
    .map((customerCtrl, i) => {
      const customer = this.customersData[i];
      const groupsArray = customerCtrl.get('groups') as FormArray;
      const selectedGroups = groupsArray.controls
        .map((gCtrl, j) => {
          const groupValue = gCtrl.value;
          return {
            ...customer.groups[j],
            selected: groupValue.selected,
            disabled: groupValue.disabled
          };
        })
        .filter(g => g.selected && g.id !== this.patchGroupId);

      return selectedGroups.length > 0
        ? {
            customerId: customer.id,
            customerName: customer.customerName,
            selectedGroups
          }
        : null;
    })
    .filter(c => c !== null);

  this.payload = selectedData.flatMap(customer =>
    customer!.selectedGroups.map(group => ({
      customerId: customer!.customerId,
      groupId: group.id
    }))
  );

  if (this.payload.length === 0) {
    this.toastr.warning(
      this.hasSelectedCustomerWithoutGroups()
        ? this.noAvailableGroupsMessage
        : 'Please select at least one customer group to publish the configuration.'
    );
    return;
  }

  const dialogRef = this.dialog.open(SelectedCustomerGroupDialogComponent, {
    width: '540px',
    data: {
      payload: this.payload,
      selectedData: selectedData
    }
  });

  dialogRef.afterClosed().subscribe(result => {
    if (result === true && this.payload.length > 0) {
      this.deviceService.promoteConfigList(this.configId, this.payload).subscribe({
        next: (data: any) => {
          if (data.status === 200) {
            this.toastr.success('Success');
            clearFormUnsavedChanges(
              this.form,
              ASSIGN_CONFIG_DIRTY_SOURCE,
              this.unsavedChanges
            );
            this.dialogRef.close(true);
          }
        },
        error: (err: any) => {
          this.toastr.error(err.error.message);
        }
      });
    }
  });
}


onCancel() {
  clearFormUnsavedChanges(
    this.form,
    ASSIGN_CONFIG_DIRTY_SOURCE,
    this.unsavedChanges
  );
  this.dialogRef.close();
}


  }
